import {mapSource} from "./SourceMapper";

export const defaultSourceOptions = [
    {value: "1065", label: mapSource("1065")},
    {value: "1067", label: mapSource("1067")},
    {value: "1081", label: mapSource("1081")},
    {value: "1093", label: mapSource("1093")},
];

export default defaultSourceOptions;
